import React, { forwardRef } from 'react';
import SimpleDayPicker from '../dayDatePickerWrapper/DayDatePickerWrapper';
import Box from '@/components/UI/box/Box';
import DatePickerWrapper from '../DatePickerWrapper';
import DatePickerManager from '../utils/DatePickerManager';
import WeekDays from '../weekDays/WeekDays';
import styles from './MultiDatepicker.module.scss';
import Arrows from '../arrows/Arrows';
const DatePicker = forwardRef(({
  checkInDate,
  checkOutDate,
  months,
  hoveredDate,
  onDayClick,
  onDayHover,
  todayDate,
  onNextPrevMonthClick,
  nextRangeDays,
  dateType = 'JALALI',
  isFull = false,
  footerChildren,
  headerChildren,
  withTooltip
}: any, ref) => {
  const datePickerIsInCurrentMonth = months.length > 0 && todayDate && todayDate.ts > months[0]?.days[0]?.ts;
  const isLastMonth = () => {
    let lastDay: any = null;
    if (months?.length > 0) {
      lastDay = months[1].days[months[1].days.length - 1];
    }
    return lastDay?.ts >= nextRangeDays?.ts;
  };
  return <Box className={styles['multi-datepicker']}>
        {headerChildren && <>{headerChildren}</>}
        <Box className={styles['calendar-wrapper']}>
          {months.length > 0 && <Arrows datePickerIsInCurrentMonth={datePickerIsInCurrentMonth} clickOnPreMonth={() => onNextPrevMonthClick(0)} dateType={dateType} months={months} monthNameConvertor={DatePickerManager.monthNameConvertor} clickOnNextMonth={() => onNextPrevMonthClick(1)} isLastMonth={isLastMonth} />}
          <Box className={styles['week-wrapper']}>
            <WeekDays />
            <WeekDays />
          </Box>
          <Box className={styles['calendar-days-container']}>
            {months.map(item => <Box key={'CALENDAR_MONTH_' + item.month} className={styles['days-container']}>
                <SimpleDayPicker pickerDate={item} hoveredDate={hoveredDate} checkInDate={checkInDate} checkOutDate={checkOutDate} onDayClick={onDayClick} onDayHover={onDayHover} todayDate={todayDate} nextRangeDays={nextRangeDays} isFull={isFull} withTooltip={withTooltip} />
              </Box>)}
          </Box>
          {footerChildren && <>{footerChildren}</>}
        </Box>
      </Box>;
});
DatePicker.displayName = 'DatePicker';
const DatePickerMultiRange = props => {
  return <>
      <DatePickerWrapper WrappedDatePicker={DatePicker} datePickerType="MULTI_COLUMN_RANGE" ref={props.dateRef} {...props} data-sentry-element="DatePickerWrapper" data-sentry-source-file="MultiDatepicker.tsx" />
    </>;
};
export default DatePickerMultiRange;